// extracted by mini-css-extract-plugin
export default {"noBackground":"qaa-z","qnaContainer":"raa-z","qna":"saa-z","question":"taa-z","modal":"uaa-z"};